function cartDrawerSectionId() {
	const drawer = document.querySelector("cart-drawer");
	const section = drawer ? drawer.closest(".shopify-section") : null;
	const prefix = "shopify-section-";

	if (section && section.id && section.id.startsWith(prefix)) {
		return section.id.slice(prefix.length);
	}

	return "cart-drawer-advanced";
}

class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.addEventListener("click", (event) => {
			if (event.target.closest("#CartDrawer-Overlay")) this.close();
		});
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		if (!cartLink) return;

		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		const wasOpen = this.isOpen === true;
		this.isOpen = true;
		if (triggeredBy) this.setActiveElement(triggeredBy);
		if (!wasOpen) this.dispatchViewEvent();
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn =
					(this.classList.contains("is-empty") &&
						this.querySelector(".drawer__inner-empty")) ||
					document.getElementById("CartDrawer") ||
					this;
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close") ||
					containerToTrapFocusOn;
				if (containerToTrapFocusOn && focusElement) {
					trapFocus(containerToTrapFocusOn, focusElement);
				}
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.isOpen = false;
		this.viewPending = false;
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	dispatchViewEvent() {
		const marker = this.querySelector("cart-items-component");
		if (!marker) return;

		if (typeof marker.dispatchViewEvent !== "function") {
			if (this.viewPending || !window.customElements || typeof customElements.whenDefined !== "function") return;
			this.viewPending = true;
			customElements
				.whenDefined("cart-items-component")
				.then(() => {
					if (!this.viewPending || !this.isOpen) return;
					this.viewPending = false;
					this.dispatchViewEvent();
				})
				.catch(() => {});
			return;
		}

		this.viewPending = false;
		try {
			marker.dispatchViewEvent();
		} catch (error) {
		}
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);

			if (!sectionElement) return;

			const source = this.getSectionDOM(
				parsedState.sections[section.id],
				section.selector
			);
			if (!source) return;

			morph(sectionElement, source, window.MORPH_OPTIONS_WITH_SCRIPTS || MORPH_OPTIONS);
		});

		this.releaseCartItems();
		this.open();
	}

	releaseCartItems() {
		this.querySelectorAll(".cart__items--disabled").forEach((element) =>
			element.classList.remove("cart__items--disabled")
		);
		this.querySelectorAll(".loading__spinner:not(.hidden)").forEach((spinner) =>
			spinner.classList.add("hidden")
		);
	}

	getSectionsToRender() {
		return [
			{
				id: cartDrawerSectionId(),
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: cartDrawerSectionId(),
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);
